import { render, staticRenderFns } from "./whatsapp-business-api.vue?vue&type=template&id=04e31f76&scoped=true&"
import script from "./whatsapp-business-api.vue?vue&type=script&lang=ts&"
export * from "./whatsapp-business-api.vue?vue&type=script&lang=ts&"
import style0 from "./whatsapp-business-api.vue?vue&type=style&index=0&id=04e31f76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e31f76",
  null
  
)

export default component.exports